import NoRows from "../../assets/img/noRows.png";

import "./NoResultTable.css";

const NoResultTable = () => {
  return (
    <div className="no-result-container">
      <img src={NoRows} alt="noRows" className="imgnoRows"/>
      <p>Nenhum resultado encontrado</p>
    </div>
  );
};

export default NoResultTable;
